// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__0cCYi"};